(() => {
  const playPauseVideo = (section, video) => {
    if (
      !section.querySelector('.banner-grid__grid').closest('.banner-grid__swiper')?.swiper ||
      video.closest('.swiper-slide-visible')
    ) {
      video.play();
    } else {
      video.pause();
    }
  };

  const initSection = (section) => {
    if (!section) return;

    const swiperEl  = section.querySelector('.banner-grid__swiper');
    const grid      = section.querySelector('.banner-grid__grid');
    const cards     = section.querySelectorAll('.banner-grid__card');
    const pagEl     = section.querySelector('.banner-grid-mixed__pagination');
    const mobileCols = parseInt(grid.getAttribute('data-slides')) || 1;
    const cardCount  = parseInt(swiperEl?.dataset.cardCount) || cards.length;
    const gapPx      = parseInt(swiperEl?.dataset.gap) || 8;

    if (!swiperEl) return;

    let swiper = null;

    const buildSwiper = (isDesktop) => {
      grid.classList.add('swiper-wrapper');
      cards.forEach((card) => card.classList.add('swiper-slide'));

      const config = {
        watchSlidesProgress: true,
        pagination: {
          el: pagEl,
          clickable: true,
          type: 'custom',
          renderCustom(_, current, total) {
            let html = '';
            for (let i = 1; i <= total; i++) {
              const active = i === current ? ' swiper-pagination-bullet-active' : '';
              html += `<span class="swiper-pagination-bullet${active}" tabindex="0" role="button" aria-label="Go to slide ${i}"></span>`;
            }
            return html;
          },
        },
        on: {
          slideChange() {
            this.slides.forEach((slide) => {
              const video = slide.querySelector('.banner-grid__card video');
              if (video) playPauseVideo(section, video);
            });
          },
        },
      };

      if (isDesktop) {
        // Desktop: show 4 cards with a peek at the 5th+
        config.slidesPerView = 4.2;
        config.spaceBetween  = gapPx;
      } else {
        // Mobile/tablet
        config.slidesPerView = mobileCols;
        config.spaceBetween  = Math.min(gapPx, 8);
      }

      swiper = new Swiper(swiperEl, config);

      // Make custom-rendered bullets clickable
      pagEl && pagEl.addEventListener('click', (e) => {
        const bullet = e.target.closest('.swiper-pagination-bullet');
        if (!bullet || !swiper) return;
        const index = Array.from(pagEl.children).indexOf(bullet);
        if (index >= 0) swiper.slideTo(index);
      });
    };

    const destroySwiper = () => {
      swiper?.destroy(true, true);
      swiper = null;
      grid.classList.remove('swiper-wrapper');
      cards.forEach((card) => {
        card.classList.remove('swiper-slide');
        card.removeAttribute('style');
      });
    };

    new ResizeObserver((entries) => {
      const [entry] = entries;
      const width      = entry.contentRect.width;
      const isDesktop  = width >= 990;
      const needsSwipe = !isDesktop || cardCount > 4;

      if (needsSwipe && !swiper) {
        buildSwiper(isDesktop);
      } else if (!needsSwipe && swiper) {
        destroySwiper();
      } else if (needsSwipe && swiper) {
        // Viewport crossed the 990px breakpoint with swipe on both sides —
        // rebuild so spaceBetween / slidesPerView update correctly.
        const wasDesktop = swiper.params.slidesPerView === 4.2;
        if (isDesktop !== wasDesktop) {
          destroySwiper();
          buildSwiper(isDesktop);
        }
      }
    }).observe(section);

    // Video intersection observer
    const videoObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          playPauseVideo(section, entry.target);
        } else {
          entry.target.pause();
        }
      });
    });

    section.querySelectorAll('.banner-grid__card video').forEach((video) => {
      videoObserver.observe(video);
    });
  };

  initSection(document.currentScript.parentElement);

  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.classList.contains('banner-grid-section')) initSection(e.target);
  });
})();
